<template>
  <!-- 소개, 자문단구성 -->
  <div>
    <div class="sub_top">
      <SubTitle></SubTitle>
      <div class="sub_tit">
          <div class="sub_tit_inner tab">
              <h2>연구단구성</h2>
          </div>
      </div>
    </div>
    <div class="ptc_container">
      <div class="m_tit">
        <div class="left">
          <h3 class="tit">조직도</h3>
        </div>
      </div>
      <div class="researchgroup web">
        <img src="@/style/new/images/info/researchgroup_web.png" usemap="#image-map-web" />
        <map name="image-map-web">
          <area alt="운영위원회" title="운영위원회" href="#1" coords="227,610,360,660" shape="rect" @click="showSteeringCommitteePopup" />
<!--          <area alt="에너지환경 측정프로토콜 전문위원회" title="에너지환경 측정프로토콜 전문위원회" href="#2" coords="1016,116,1274,159" shape="rect" />-->
<!--          <area alt="분석프로토콜 전문 위원회" title="분석프로토콜 전문 위원회" href="#3" coords="1015,172,1276,215" shape="rect" />-->
<!--          <area alt="스마트IT 프로토콜 전문 위원회" title="스마트IT 프로토콜 전문 위원회" href="#4" coords="1015,468,1273,507" shape="rect" />-->
<!--          <area alt="구조안전 프로토콜 전문 위원회" title="구조안전 프로토콜 전문 위원회" href="#5" coords="1016,818,1277,860" shape="rect" />-->
        </map>
      </div>
      <div class="researchgroup mobile">
        <img src="@/style/new/images/info/researchgroup_mobile.png" usemap="#image-map-mobile" />
        <map name="image-map-mobile">
          <area alt="운영위원회" title="운영위원회" href="#1" coords="242,280,376,331" shape="rect" @click="showSteeringCommitteePopup" />
<!--          <area alt="에너지환경 측정프로토콜 전문위원회" title="에너지환경 측정프로토콜 전문위원회" href="#2" coords="118,588,378,628" shape="rect" />-->
<!--          <area alt="분석프로토콜 전문 위원회" title="분석프로토콜 전문 위원회" href="#3" coords="118,642,378,685" shape="rect" />-->
<!--          <area alt="스마트IT 프로토콜 전문 위원회" title="스마트IT 프로토콜 전문 위원회" href="#4" coords="121,1319,375,1363" shape="rect" />-->
<!--          <area alt="구조안전 프로토콜 전문 위원회" title="구조안전 프로토콜 전문 위원회" href="#5" coords="119,1996,378,2040" shape="rect" />-->
        </map>
      </div>
      <div class="m_tit">
        <div class="left">
          <h3 class="tit">자문단</h3>
        </div>
        <div class="right">
          <div class="search_filter_inp">
            <select :value="search_type">
              <option value="">소속 + 이름</option>
              <option value="search_dept">소속</option>
              <option value="search_name">이름</option>
            </select>
            <input type="text" @keyup="inputEnter" :value="search_keyword">
            <button type="button" @click="search"></button>
            <!-- //2023-12-13 수정 -->
          </div>
        </div>
      </div>
      <div class="tbl_wrap">
        <table class="tbl_style typ2">
          <colgroup>
            <col style="width: 18%" />
            <col style="width: 18%" />
            <col style="width: 15%" />
            <col style="width: 15%" />
            <col style="width: 15%" />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th>{{$t('message.위원회')}}</th>
            <th>{{$t('message.분야')}}</th>
            <th>{{$t('message.소속')}}</th>
            <th>{{$t('message.이름')}}</th>
            <th>{{$t('message.직급')}}</th>
            <th>{{$t('message.비고')}}</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="( item , i ) in searchList">
            <template v-for="( info , j ) in item.list">
              <template v-for="( member , k ) in info.members">
                <tr :key="`tr-${i}-${j}-${k}`" :class="(j === 0 && k === 0) ? 'hit' : null">
                  <th :rowspan="listLength(i)" v-if="j === 0 && k === 0" :key="`item-title-${i}`" class="fs1">
                    {{ item.title }}
                  </th>
                  <th :rowspan="info.members.length" v-if="k === 0" :key="`item-type-${j}`" class="fs1">
                    {{ info.type }}
                  </th>
                  <td>{{ member.affiliation }}</td>
                  <td>{{ member.name }}</td>
                  <td>{{ member.title }}</td>
                  <td>{{ member.note }}</td>
                </tr>
              </template>
            </template>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <steering-committee-popup :crntObj="SteeringCommitteePopupObj"/>
  </div>
</template>

<script>
export default {
  components: {
    MiddleContainer : _=> import( '@/components/platform/MiddleContainer' ) , 
    ContentHeader : _=> import( '@/components/platform/ContentHeader' ) , 
    SteeringCommitteePopup : _=> import( '@/views/Platform/Introduce/comp/SteeringCommitteePopup' ) , 
    SubTitle : _=> import( '@/views/Platform/Introduce/SubTitle' ) , 
  },
  data() {
    return {
      search_name : "",
      search_dept : "",
      search_type : "",
      search_keyword : "",
      SteeringCommitteePopupObj : {
        openBln : false , 
        closeHandler : _=> {
          this.SteeringCommitteePopupObj.openBln = false ; 
        } , 
      } ,
      searchList : [{}],
      tabList : [
        {
          title : '분석프로토콜 전문위원회' , 
          list : [
            {
              type : '' , 
              members : [
                { name : '김낙균' , title : '위원장' , affiliation : 'KIST' , Remarks : '' } , 
              ] , 
            } , 
            {
              type : 'SEM/EDS, FIB, EPMA' , 
              members : [
                { name : '김혜령' , title : '간사' , affiliation : '	KIST' , note : '' } , 
                { name : '정영우' , title : '위원' , affiliation : '	KIST' , note : '' } , 
                { name : '김지영' , title : '위원' , affiliation : '	KIST' , note : '' } , 
                { name : '김소희' , title : '위원' , affiliation : '	KIST' , note : '' } , 
                { name : '김규태' , title : '위원' , affiliation : '	고려대' , note : '' } , 
                { name : '강주희' , title : '위원' , affiliation : '	KIMS' , note : '' } , 
                { name : '민봉기' , title : '위원' , affiliation : '	영남대' , note : '' } , 
              ] , 
            } , 
            {
              type : 'TEM' , 
              members : [
                { name : '조민경' , title : '간사' , affiliation : '	KIST' , note : '' } , 
                { name : '권덕황' , title : '위원' , affiliation : '	KIST' , note : '' } , 
                { name : '박주철' , title : '위원' , affiliation : '	구미전자정보기술원' , note : '' } , 
                { name : '백현석' , title : '위원' , affiliation : '	KBSI' , note : '' } , 
              ] , 
            } , 
            {
              type : 'APT' , 
              members : [
                { name : '이지영' , title : '' , affiliation : '   	KIST' , note : '' } , 
                { name : '이봉호' , title : '위원' , affiliation : '	DGIST' , note : '' } , 
                { name : '김윤준' , title : '위원' , affiliation : '	인하대' , note : '' } , 
                { name : '설재복' , title : '위원' , affiliation : '	경상대학교' , note : '' } , 
              ] , 
            } , 
            {
              type : 'X-ray' , 
              members : [
                { name : '원성옥' , title : '간사' , affiliation : '	KIST' , note : '' } , 
                { name : '김승주' , title : '위원' , affiliation : '	아주대학교 ' , note : '' } , 
                { name : '김용일' , title : '위원' , affiliation : '	KRISS' , note : '' } , 
                { name : '류학기' , title : '위원' , affiliation : '	아주대' , note : '' } , 
                { name : '신태주' , title : '위원' , affiliation : '	UNIST' , note : '' } , 
                { name : '정성욱' , title : '위원' , affiliation : '	한승케미칼' , note : '' } , 
              ] , 
            } , 
            {
              type : 'XPS' , 
              members : [
                { name : '박수형' , title : '간사' , affiliation : '	KIST' , note : '' } , 
                { name : '이현복' , title : '위원' , affiliation : '	강원대' , note : '' } , 
                { name : '이연진' , title : '위원' , affiliation : '	연세대' , note : '' } , 
                { name : '배종성' , title : '위원' , affiliation : '	KBSI' , note : '' } , 
              ] , 
            } , 
            {
              type : 'Raman' , 
              members : [
                { name : '김지영' , title : '간사' , affiliation : '	KIST' , note : '' } , 
                { name : '김현우' , title : '위원' , affiliation : '	KRICT' , note : '' } , 
                { name : '이관형' , title : '위원' , affiliation : '	서울대' , note : '' } , 
              ] , 
            } , 
            {
              type : 'Nanoindentor' , 
              members : [
                { name : '이지혜' , title : '간사' , affiliation : '	KIST' , note : '' } , 
                { name : '우윤성' , title : '위원' , affiliation : '	단국대' , note : '' } , 
              ] , 
            } , 
            {
              type : 'TGA' , 
              members : [
                { name : '신태주' , title : '위원' , affiliation : '	UNIST' , note : '' } , 
              ] , 
            } , 
            {
              type : 'AFM' , 
              members : [
                { name : '이지혜' , title : '위원' , affiliation : '	KIST' , note : '' } , 
                { name : '신채호' , title : '위원' , affiliation : '	KRISS' , note : '' } , 
                { name : '김윤석' , title : '위원' , affiliation : '	성균관대' , note : '' } , 
                { name : '박병천' , title : '위원' , affiliation : '	KRISS' , note : '' } , 
                { name : '고재현' , title : '위원' , affiliation : '	한림대' , note : '' } , 
              ] , 
            } , 
            {
              type : 'FT-IR' , 
              members : [
                { name : '손석연' , title : '위원' , affiliation : '	KIST' , note : '' } , 
                { name : '유현웅' , title : '위원' , affiliation : '	KRISS' , note : '' } , 
              ] , 
            } , 
            {
              type : 'SIMS' , 
              members : [
                { name : '장윤정' , title : '위원' , affiliation : '	KIST' , note : '' } , 
                { name : '김경중' , title : '위원' , affiliation : '	KRISS' , note : '' } , 
                { name : '홍태은' , title : '위원' , affiliation : '	KBSI' , note : '' } , 
                { name : '김정민' , title : '위원' , affiliation : '	KBSI' , note : '' } , 
              ] , 
            } , 
            {
              type : 'Elipsometer' , 
              members : [
                { name : '조현모' , title : '위원' , affiliation : '	KRISS' , note : '' } , 
              ] , 
            } , 
            {
              type : 'SQUID' , 
              members : [
                { name : '김기웅' , title : '위원' , affiliation : '	충북대' , note : '' } , 
              ] , 
            } , 
            {
              type : 'ICP' , 
              members : [
                { name : '박경수' , title : '위원' , affiliation : '	KIST' , note : '' } , 
                { name : '한선호' , title : '위원' , affiliation : '	(전) KAERI' , note : '' } , 
                { name : '정성욱' , title : '위원' , affiliation : '	㈜ 한승케이칼' , note : '' } , 
              ] , 
            } , 
          ] , // end of list
        } , 
        {
          title : '에너지환경 측정프로토콜 전문위원회' , 
          list : [
            { 
              type : '총괄' , 
              members : [
                { name : '황진하' , title :	'위원장' , affiliation : '홍익대 신소재공학과(교수)' , note : '' } , 
              ]
            } , 
            { 
              type : '이차전지' , 
              members : [
                { name : '정규남' , title :	'위원' , affiliation : 'KIER 변환저장소재연구실(선임연구원)' , note : '이차전지 부문간사' } , 
                { name : '정경윤' , title :	'위원' , affiliation : 'KIST 에너지 저장연구센터(책임연구원)' , note : '' } , 
                { name : '이종원' , title :	'위원' , affiliation : 'DGIST 에너지공학전공(조교수)' , note : '' } , 
                { name : '박민식' , title :	'위원' , affiliation : '경희대 정보전자신소재공학과(부교수)' , note : '' } , 
                { name : '이동욱' , title :	'위원' , affiliation : '홍익대 신소재공학과 (조교수)' , note : '' } , 
              ]
            } , 
            { 
              type : '연료전지' , 
              members : [
                { name : '박종성' , title :	'위원' , affiliation : '명지대(부교수)' , note : '연료전지 부문간사' } , 
                { name : '송선주' , title :	'위원' , affiliation : '전남대 신소재공학부(교수)' , note : '' } , 
                { name : '명재하' , title :	'위원' , affiliation : '인천대 신소재공학과(조교수)' , note : '' } , 
                { name : '윤희성' , title :	'위원' , affiliation : '한양대 산학협력단 (연구교수:21/09~)' , note : '' } , 
                { name : '지호일' , title :	'위원' , affiliation : 'KIST 에너지소재 연구단(선임연구원)' , note : '' } , 
                { name : '김현식' , title :	'위원' , affiliation : '홍익대 신소재공학과(조교수)' , note : '' } , 
              ]
            } , 
            { 
              type : '태양전지' , 
              members : [
                { name : '엄태식' , title :	'위원' , affiliation : '홍익대학교 화학공학과(조교수)' , note : '태양전지 부문간사' } , 
                { name : '이병훈' , title :	'위원' , affiliation : '이화여대 화학신소재공학 전공(부교수)' , note : '2022년 신규' } , 
                { name : '김봉훈' , title :	'위원' , affiliation : '숭실대 유기신소재 파이버공학과(조교수)' , note : '2022년 신규' } , 
                { name : '박진주' , title :	'위원' , affiliation : '청주대 태양광에너지공학과(조교수)' , note : '2022년 신규' } , 
              ]
            } , 
            { 
              type : '열전소자' , 
              members : [
                { name : '김현식' , title :	'위원' , affiliation : '서울시립대학교' , note : '열전소자 부문간사' } , 
                { name : '이규형' , title :	'위원' , affiliation : '연세대 신소재공학과(교수)' , note : '2022년 신규' } , 
                { name : '신원호' , title :	'위원' , affiliation : '광운대 전자재료공학과(부교수)' , note : '2022년 신규' } , 
                { name : '노종욱' , title :	'위원' , affiliation : '경북대 나노소재공학부(조교수)' , note : '2022년 신규' } , 
              ]
            } , 
          ] , 
        } , 
        {
          title : '스마트IT 프로토콜 전문위원회' , 
          list : [
            { 
              type : 'ReRAM(메모리)' , 
              members : [
                { name : '박배호'	, title : '위원장(메모리)' , affiliation : '건국대학교 물리학과 (교수)' , note : 'ReRAM(메모리)간사 겸직' } , 
                { name : '우지용'	, title : '위원' , affiliation : '경북대학교, IT대학전자공학부 (조교수)' , note : '' } , 
                { name : '윤태식'	, title : '위원' , affiliation : 'UNIST, 반도체부품소재대학원 (교수)' , note : '' } , 
                { name : '이명재'	, title : '위원' , affiliation : 'DGIST,바이오·자성글로벌융합센터 (책임연구원)' , note : '' } , 
              ] , 
            } , 
            { 
              type : 'PRAM(메모리)' , 
              members : [
                { name : '부상돈'	, title : '위원' , affiliation : '전북대 물리학과 (교수)' , note : 'PRAM(메모리)간사' } , 
                { name : '김태헌'	, title : '위원' , affiliation : '울산대학교 물리학과 (부교수)' , note : '' } , 
                { name : '이상한'	, title : '위원' , affiliation : '광주과기원 신소재공학부 (교수)' , note : '' } , 
                { name : '김윤석'	, title : '위원' , affiliation : '성균관대 신소재공학부 (부교수)' , note : '' } , 
              ]
            } , 
            { 
              type : 'MRAM(메모리)' , 
              members : [
                { name : '박병국'	, title : '위원' , affiliation : 'KAIST 재료공학부 (부교수)' , note : 'MRAM(메모리)간사' } , 
                { name : '이경진'	, title : '위원' , affiliation : 'KAIST 물리학과 (교수)' , note : '' } , 
                { name : '김상훈'	, title : '위원' , affiliation : '울산대학교, 물리학과 (조교수)' , note : '' } , 
                { name : '백승헌'	, title : '위원' , affiliation : 'KIST (선임연구원)' , note : '' } , 
              ] 
            } , 
            { 
              type : 'OLED(디스플레이)' , 
              members : [
                { name : '고재현'	, title : '위원장(디스플레이)' , affiliation : '한림대 (교수)' , note : 'OLED(디스플레이)간사 겸직' } , 
                { name : '김정호'	, title : '위원' , affiliation : '경희대학교 정보디스플레이학과 (정교수)' , note : '' } , 
                { name : '서민철'	, title : '위원' , affiliation : '경희대 (교수)' , note : '' } , 
              ] 
            } , 
            { 
              type : 'LCD와 양자점(디스플레이)' , 
              members : [
                { name : '최윤석'	, title : '위원' , affiliation : '한밭대학교 전자공학과 (정교수)' , note : 'LCD와 양자점(디스플레이)간사' } , 
                { name : '유창재'	, title : '위원' , affiliation : '한양대 공과대학 융합전자공학부 (정교수)' , note : '' } , 
                { name : '김학린'	, title : '위원' , affiliation : '경북대학교 IT대학 전자공학부 (정교수)' , note : '' } , 
                { name : '문대규'	, title : '위원' , affiliation : '순천향대 (교수)' , note : '마이크로LED와 미래디스플레이(디스플레이) 간사' } , 
                { name : '김영우'	, title : '위원' , affiliation : '한국광기술원 (수석연구원, 본부장)' , note : '' } , 
                { name : '이인환'	, title : '위원' , affiliation : '고려대 신소재공학부 (교수)' , note : '' } , 
              ]
            } , 
          ] , 
        } , 
        {
          title : '구조안전 프로토콜 전문위원회' , 
          list : [
            {
              type : '철강/금속' , 
              members : [
                { name : '박신화' , title : '총괄위원장' , affiliation : '서울과기대' , note : '' } , 
                { name : '박중철' , title : '위원' , affiliation : 'Rist' , note : '' } , 
                { name : '박병민' , title : '위원' , affiliation : '(주)성광기업' , note : '' } , 
                { name : '정성욱' , title : '위원' , affiliation : '한승케미칼' , note : '' } , 
                { name : '조영모' , title : '위원' , affiliation : '전)포스코' , note : '' } , 
                { name : '조다희' , title : '위원' , affiliation : 'Rist' , note : '' } , 
                { name : '양원존' , title : '위원' , affiliation : '한국재료연구원' , note : '' } , 
                { name : '박이호' , title : '위원' , affiliation : '한국재료연구원' , note : '' } , 
                { name : '김민석' , title : '위원' , affiliation : '가천대' , note : '' } , 
                { name : '손지하' , title : '위원' , affiliation : 'TCC스틸' , note : '' } , 
                { name : '홍현욱' , title : '위원' , affiliation : '창원대' , note : '' } , 
                { name : '공병욱' , title : '위원' , affiliation : '창원대' , note : '' } , 
                { name : '정민주' , title : '위원' , affiliation : '스틸이앤지' , note : '' } , 
                { name : '이영만' , title : '위원' , affiliation : '스틸이앤지' , note : '' } , 
              ] , 
            } , 
            {
              type : '무기∙세라믹' , 
              members : [
                { name : '박희동' , title : '분과전문위원장' , affiliation : '(구) 한국화학연구원' , note : '' } , 
                { name : '유병환' , title : '위원' , affiliation : '한국화학연구원' , note : '' } , 
                { name : '한선호' , title : '위원' , affiliation : '(구) 한국원자력연구원' , note : '' } , 
                { name : '이선홍' , title : '위원' , affiliation : '한국세라믹기술원' , note : '' } , 
                { name : '이명규' , title : '위원' , affiliation : '한국세라믹기술원' , note : '' } , 
                { name : '손경식' , title : '위원' , affiliation : '한국세라믹기술원' , note : '' } , 
                { name : '한병동' , title : '위원' , affiliation : '한국재료연구원' , note : '' } , 
              ] , 
            } , 
            {
              type : '고분자' , 
              members : [
                { name : '신태주' , title : '분과전문위원장' , affiliation : '울산과학기술원' , note : '' } , 
                { name : '윤진환' , title : '위원' , affiliation : '부산대학교' , note : '' } , 
                { name : '홍성우' , title : '위원' , affiliation : '한국생산기술연구원' , note : '' } , 
                { name : '김세현' , title : '위원' , affiliation : '건국대학교' , note : '' } , 
                { name : '이은지' , title : '위원' , affiliation : '광주과학기술원' , note : '' } , 
              ] , 
            } , 
          ]
        } , 
      ] , 
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    listLength(i){
      let slIdx = 0;
      this.searchList[i].list.forEach((member) => {
        slIdx += member.members.length;
      });
      return slIdx;
    },
    inputEnter(event) {
      this.search_keyword = event.target.value
      if(event.code === 'Enter' || event.keyCode === 13) {
        this.search();
      }
    },
    search(){
      this.searchList = JSON.parse(JSON.stringify(this.tabList));
      if(this.search_type == "search_name" && this.search_keyword != "") {
        this.searchList = this.searchList.filter((tab) => {tab.list = tab.list.filter((obj) => {obj.members = obj.members.filter((member => member.name.indexOf(this.search_keyword) > -1)); return obj.members.length > 0;}); return tab.list.length > 0;});
      } else if(this.search_type == "search_dept" && this.search_keyword != "") {
        this.searchList = this.searchList.map((tab) => tab.list.map((obj) => obj.members.filter((member => member.affiliation.indexOf(this.search_keyword) > -1))));
      } else if(this.search_keyword != "") {
        this.searchList = this.searchList.filter((tab) => {tab.list = tab.list.filter((obj) => {obj.members = obj.members.filter((member => member.name.indexOf(this.search_keyword) > -1 || member.affiliation.indexOf(this.search_keyword) > -1)); return obj.members.length > 0;}); return tab.list.length > 0;});
        // this.searchList = this.searchList.map((tab) => tab.list.map((obj) => obj.members.filter((member => member.affiliation.indexOf(this.search_keyword) > -1 || member.name.indexOf(this.search_keyword) > -1))));
      }
    },
    showSteeringCommitteePopup () {
      this.SteeringCommitteePopupObj = { 
        ...this.SteeringCommitteePopupObj , 
        openBln : true , 
      } ; 
    }
  }
};
</script>
